import { FC, HTMLProps } from 'react';

export const DashboardIcon: FC<HTMLProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <mask id="mask0_4674_3133" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
        <rect width="24" height="24" fill="white" />
      </mask>
      <g mask="url(#mask0_4674_3133)">
        <path
          d="M10.2528 5.88415L10.5312 10.0241L10.6694 12.1049C10.6709 12.3189 10.7044 12.5315 10.7691 12.7358C10.936 13.1324 11.3376 13.3844 11.7745 13.3668L18.4317 12.9313C18.72 12.9266 18.9984 13.0344 19.2056 13.2311C19.3783 13.395 19.4898 13.6094 19.525 13.84L19.5368 13.98C19.2613 17.7947 16.4596 20.9765 12.6528 21.7978C8.84591 22.6191 4.94222 20.8841 3.06107 17.5347C2.51875 16.5616 2.18001 15.4921 2.06474 14.3888C2.01659 14.0622 1.99539 13.7323 2.00134 13.4023C1.99539 9.31254 4.90784 5.77677 8.9847 4.92438C9.47538 4.84797 9.95639 5.10773 10.1532 5.55534C10.2041 5.659 10.2377 5.77002 10.2528 5.88415Z"
          fill="currentColor"
        />
        <path
          opacity="0.4"
          d="M22.0002 9.8118L21.9932 9.84439L21.973 9.89178L21.9758 10.0219C21.9654 10.1942 21.8988 10.36 21.7842 10.494C21.6647 10.6335 21.5015 10.7285 21.3218 10.7654L21.2122 10.7804L13.5314 11.2781C13.2759 11.3033 13.0215 11.2209 12.8316 11.0515C12.6732 10.9102 12.572 10.7196 12.5434 10.5142L12.0279 2.84457C12.0189 2.81864 12.0189 2.79053 12.0279 2.76459C12.0349 2.55318 12.128 2.35335 12.2863 2.20974C12.4445 2.06613 12.6549 1.99071 12.8702 2.00033C17.4301 2.11634 21.2625 5.3953 22.0002 9.8118Z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
};
